define(['jquery'], function($){
	'use strict';

	const PLUGIN_NAME = 'affiliate';

	const DEBUG = false;

	const DEFAULTS = {
		cookie:{
			lifetime: 30, // days
			name: 'affiliate',
			productionSite: 'flexi-risk.koop.cz'
		},
		selectors: {
			input: 'input[name="frm.affiliate"]'
		},
		urlParamName: 'affiliate'
	};

	// The actual plugin constructor
	function Affiliate(element, options) {
		let self = this;

		clog('constructor');

		self.element = element;
		self.$me = $(this.element);

		self.options = $.extend(true, {}, DEFAULTS, options);

		self.objects = {};
		self.data = {};

		self.initialise();
	}

	/**
	 * init
	 */
	Affiliate.prototype.initialise = function() {
		let self = this;
		self.mapObjects();
		self.bindEvents();
	};

	Affiliate.prototype.mapObjects = function() {
		let self = this;
		self.objects.$inputs = $('form', document).find(self.options.selectors.input);
	};

	/**
	 *  bind all custom events
	 */
	Affiliate.prototype.bindEvents = function() {
		let self = this;
		$(window).on('load.'+PLUGIN_NAME, function() {
			self.getAffiliate();
			self.storeAffiliate();
		});
	};

	/**
	 * Ziska aktualni affiliate kod z URL
	 */
	Affiliate.prototype.getAffiliate = function () {
		let self = this;
		self.data.newAffiliate = _getUrlParameter(self.options.urlParamName);
		clog('new aff: ' + self.data.newAffiliate);
	};

	/**
	 * Pokud je ulozeny affiliate kod jiz v cookie ulozeny, prodlouzi platnost cookie
	 * Pokud kod ulozeny neni, prida tento ke stavajicim kodum
	 */
	Affiliate.prototype.storeAffiliate = function () {
		let self = this;

		let oldAffiliate = _readCookie() || '';

		if (!self.data.newAffiliate) {
				self._fillInputField(oldAffiliate);
		} else {
			let newAffiliate = (!!oldAffiliate) ? oldAffiliate + '|' + self.data.newAffiliate : self.data.newAffiliate;
			clog('oldAffiliate',oldAffiliate,'newAffiliate',newAffiliate);

			if ( oldAffiliate.indexOf(self.data.newAffiliate) !== -1 ) {
				_prolongCookie(self.options.cookie.name);
				self._fillInputField(oldAffiliate);
			} else {
				_createCookie(self.options.cookie.name, newAffiliate);
				self._fillInputField(newAffiliate);
			}
		}
	};

	Affiliate.prototype._fillInputField = function (value) {
		let self = this;
		let inputs = document.querySelectorAll( self.options.selectors.input );
		// MSIE fix, @see https://developer.mozilla.org/en-US/docs/Web/API/NodeList#Example
		Array.prototype.forEach.call(inputs, function (item) {
			item.value = value;
		});
	};

	let _getUrlParameter = function (name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		let results = regex.exec(location.search);
		return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
	};

	// ********************  C O O K I E S  ******************** //
	let _createCookie = function(name, value, days) {
		name = name || DEFAULTS.cookie.name;
		days = days || DEFAULTS.cookie.lifetime;
		value = value || _readCookie(name);

		let expires = new Date().setTime( new Date().getTime() + (days * 24 * 60 * 60 * 1000) );

		clog(value, value);
		let cookie_string = name + "=" + value;
		cookie_string += ";expires=" + (new Date(expires).toUTCString()); // Chrome Bug - @see https://stackoverflow.com/a/35025574
		cookie_string += ";path=/";
		// TEST THIS for production subdomains
		// if (window.location.hostname === DEFAULTS.cookie.productionSite) {
		// 	cookie_string += ";domain=." + DEFAULTS.cookie.productionSite; // '.' -> allow subdomains access to the cookie
		// }
		if (window.location.hostname !== 'localhost') {
			cookie_string += ";secure";
		}
		clog('name, value, days, cookie_string', name, value, days, cookie_string);
		document.cookie = cookie_string;
	};
	let _readCookie = function(name) {
		let cookieName = name || DEFAULTS.cookie.name;
		let match = document.cookie.match(new RegExp(cookieName + '=([^;]+)'));
		return match ? match[1] : null;
	};
	let _prolongCookie = function(name, days) {
		let cookieName = name || DEFAULTS.cookie.name;
		let cookieVal = _readCookie( cookieName );
		_createCookie( cookieName, cookieVal, days || DEFAULTS.cookie.lifetime );
	};

	// simple logger
	let clog = function() {
		if (DEBUG && window.console) {
			console.group(PLUGIN_NAME + ' debug:');
			for ( let arg in arguments ) {
				if (arguments.hasOwnProperty(arg)) console.log( arguments[arg] );
			}
			console.groupEnd();
		}
	};


	/**
	 * decide, which methods will be "public"
	 */
	let API = {
		//action: Affiliate.prototype.action
	};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 *         if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function(value) {
		let args = arguments;

		return this.each(function() {
			let $this = $(this);

			// get plugin instance
			let plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new Affiliate(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};
});



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/jquery.affiliate.js